/**
 * Static device  model numbers used for devices sensor texts and pairing information.
 */
export enum DeviceModelNumber {
  'HEM-9200T' = 'HEM-9200T',
  'HEM-9210T' = 'HEM-9210T',
  'MightySatRx-9909' = 'MightySatRx-9909',
  'MightySatRx-9809' = 'MightySatRx-9809',
  'MIRSmartOne' = 'MIRSmartOne',
  'MIRSpirobankSmart' = 'MIRSpirobankSmart',
  'MIRSpirobankII' = 'MIRSpirobankII',
  'Marsden_M_550' = 'Marsden_M_550',
  'VivaLNK_VV330_C8' = 'VivaLNK_VV330_C8',
  'Janacare_AINA' = 'Janacare_AINA',
}

export type DeviceModelNumberType = `${DeviceModelNumber}`;
